import React from 'react';
import { Card } from 'antd';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { getFormattedDouble } from '../../utils/format';

const MyPieChart = ({ title, data, show }) => (
  <Card title={title}>
    <ResponsiveContainer width="100%" height={500}>
      {
        show ? (
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ value }) => `${getFormattedDouble(value)}%`}
              outerRadius="66%"
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value}%`} />
            <Legend />
          </PieChart>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 500 }}>
            <div>Projeção não informada</div>
          </div>
        )
      }
    </ResponsiveContainer>
  </Card>
);

export default MyPieChart;
